import {doc} from '../docs.js';
import {float} from './utils.js';
import {extractCode} from './extract.js';
import {lazy} from './lazy.js';

doc(
    "gl.fwidth",
    {
        "x": "",
    },
    "Creates GLSL expression calculating fwidth (partial derivative) of inlet",
    () => 1,
    {
        tags: "GLSL",
        inlets: 1,
    });

const gl_fwidth = (object) => {
    object.needsHotReload = true;
    return lazy((a) => {
        a = a || {};
        let aCode = a.code || a || "0.";
        object.flash();
        return `fwidth(${float(aCode)})`;
    });
};

doc(
    "gl.sqrt",
    {
        "x": "",
    },
    "Creates GLSL expression calculating sqrt of inlet",
    () => 1,
    {
        tags: "GLSL",
        inlets: 1,
    });

const gl_sqrt = (object) => {
    object.needsHotReload = true;
    return lazy((a) => {
        a = a || {};
        let aCode = a.code || a || "0.";
        object.flash();
        return `sqrt(${float(aCode)})`;
    });
};

doc(
    "gl.floor",
    {
        "x": "",
    },
    "Creates GLSL expression calculating floor of inlet",
    () => 1,
    {
        tags: "GLSL",
        inlets: 1,
    });

const gl_floor = (object) => {
    object.needsHotReload = true;
    return lazy((a) => {
        a = a || {};
        let aCode = a.code || a || "0.";
        object.flash();
        return `floor(${float(aCode)})`;
    });
};
doc(
    "gl.ceil",
    {
        "x": "",
    },
    "Creates GLSL expression calculating ceil of inlet",
    () => 1,
    {
        tags: "GLSL",
        inlets: 1,
    });

const gl_ceil = (object) => {
    object.needsHotReload = true;
    return lazy((a) => {
        a = a || {};
        let aCode = a.code || a || "0.";
        object.flash();
        return `ceil(${float(aCode)})`;
    });
};


doc(
    "gl.rand",
    {
        "x": "",
    },
    "Creates GLSL expression for calculating a pseudo-random number given a vec2",
    () => 1,
    {
        tags: "GLSL",
        inlets: 1,
    });

const gl_rand = (object) => {
    object.needsHotReload = true;
    return lazy((a) => {
        a = a || {};
        let aCode = a.code || a || "vec2(0.,0.)";
        object.flash();
        return `rand(${float(aCode)})`;
    });
};

doc(
    "gl.sin",
    {
        "x": "",
    },
    "Creates GLSL expression calculating sin of inlet",
    () => 1,
    {
        tags: "GLSL",
        inlets: 1,
    });

const gl_sin = (object) => {
    object.needsHotReload = true;
    return lazy((a) => {
        a = a || {};
        let aCode = a.code || a || "0.";
        object.flash();
        return `sin(${float(aCode)})`;
    });
};

doc(
    "gl.cos",
    {
        "x": "",
    },
    "Creates GLSL expression calculating cosine of inlet",
    () => 1,
    {
        tags: "GLSL",
        inlets: 1,
    });

const gl_cos = (object) => {
    object.needsHotReload = true;
    return lazy((a) => {
        a = a || {};
        let aCode = a.code || a || "0.";
        object.flash();
        return `cos(${aCode})`;
    });
};

doc(
    "gl.tan",
    {
        "x": "",
    },
    "Creates GLSL expression calculating tangent of inlet",
    () => 1,
    {
        tags: "GLSL",
        inlets: 1,
    });

const gl_tan = (object) => {
    object.needsHotReload = true;
    return lazy((a) => {
        a = a || {};
        let aCode = a.code || a || "0.";
        object.flash();
        return `tan(${float(aCode)})`;
    });
};

doc(
    "gl.atan",
    {
        "y": "",
        "x": "",
    },
    "Creates GLSL expression calculating arc-tangent of inlets",
    () => 1,
    {
        isHot: true,
        tags: "GLSL",
        inlets: 2,
    });

const gl_atan = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
        object.flash();
        return `atan(${float(codes[0])}, ${float(codes[1])})`;
    }, b);
};

doc(
    "gl.atan2",
    {
        "y": "",
        "x": "",
    },
    "Creates GLSL expression calculating arc-tangent 2 of inlets",
    () => 1,
    {
        isHot: true,
        tags: "GLSL",
        inlets: 2,
    });

const gl_atan2 = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
        object.flash();
        return `ATan2(${float(codes[0])}, ${float(codes[1])})`;
    }, b);
};

doc(
    "gl.pow",
    {
        "y": "",
        "x": "",
    },
    "Creates GLSL expression calculating pow (exponent) of inlets",
    () => 1,
    {
        isHot: true,
        tags: "GLSL",
        inlets: 2,
    });

const gl_pow = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
        object.flash();
        return `pow(${float(codes[0])}, ${float(codes[1])})`;
    }, b);
};

doc(
    "gl.smoothstep",
    {
        a:"",
        b:"",
        c:"",
    },
    "Creates GLSL expression calculating smoothstep of inlets",
    () => 1,
    {
        isHot: true,
        tags: "GLSL",
        inlets: 3,
    });

const gl_smoothstep = (object, b,c ) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b,c);
        object.flash();
        return `smoothstep(${float(codes[0])}, ${float(codes[1])}, ${float(codes[2])})`;
    }, b, c);
};

export const math = {
    "gl.sin" : gl_sin,
    "gl.cos" : gl_cos,
    "gl.tan" : gl_tan,
    "gl.atan": gl_atan,
    "gl.atan2": gl_atan2,
    "gl.pow": gl_pow,
    "gl.floor": gl_floor,
    "gl.ceil": gl_ceil,
    "gl.sqrt": gl_sqrt,
    "gl.smoothstep": gl_smoothstep,
    "gl.rand": gl_rand,
    "gl.fwidth": gl_fwidth,
};
